<template>
  <div class="home-container">
    <!-- 顶部导航栏 -->
    <el-header class="header">
      <div class="system-title">汽车配件管理系统</div>
    </el-header>

    <el-container>
      <!-- 主内容区 -->
      <el-main class="main-content">
        <el-menu
          default-active="dashboard"
          class="el-menu-demo" 
          mode="horizontal"
          @select="handleMenuSelect"
        >
          <el-menu-item index="home/DataBoardViews/DataBoard">
            <i class="el-icon-data-line"></i>
            <span slot="title">数据看板</span>
          </el-menu-item>

          <el-menu-item index="home/AutomotivePartsViews/AutoPartsInventory">
            <i class="el-icon-box"></i>
            <span slot="title">库存清单</span>
          </el-menu-item>

          <el-submenu index="home/OrderViews">
            <template slot="title">
              <i class="el-icon-tickets"></i>
              <span>订单管理</span>
            </template>
            <el-menu-item index="home/OrderViews/OrderInfo">订单中心</el-menu-item>
            <el-menu-item index="home/OrderViews/OrderDetail">订单详情</el-menu-item>
            <el-menu-item index="home/OrderViews/SupplierOrder">供应商结款</el-menu-item>
          </el-submenu>

          <el-submenu index="home/BusinessPartnerViews">
            <template slot="title">
              <i class="el-icon-truck"></i>
              <span>合作伙伴</span>
            </template>
            <el-menu-item index="home/BusinessPartnerViews/CustomerInfo">客户</el-menu-item>
            <el-menu-item index="home/BusinessPartnerViews/SupplierInfo">供应商</el-menu-item>
          </el-submenu>

          <el-menu-item index="home/DataBoardViews/StatisticalReport">
            <i class="el-icon-data-analysis"></i>
            <span slot="title">统计报表</span>
          </el-menu-item>

          <el-menu-item index="home/DataBoardViews/RebateInfo">
            <i class="el-icon-data-analysis"></i>
            <span slot="title">返点</span>
          </el-menu-item>
        </el-menu>

        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  mounted() {

  },
  methods: {
    handleMenuSelect(index) {
      this.$router.push(`/${index}`);
    },
  }
}
</script>

<style scoped>
.home-container {
  height: 20px;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #1a2849;
  color: white;
  padding: 0 20px;
}

.system-title {
  font-size: 24px;
  font-weight: bold;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;
  cursor: pointer;
}

.sidebar {
  background: #fff;
  border-right: 1px solid #e6e6e6;
}

.main-content {
  background: #f5f7fa;
  padding: 10px;
}
</style>